/**
 * Independent rental-price floors: blank is absence, not zero.
 * These conversions do not apply pricing defaults or relax validation.
 */
export function hydrateOptionalMinimumPrice(value: unknown): string {
  return value == null ? "" : String(value);
}

export function serializeOptionalMinimumPrice(value: string): number | null {
  return value.trim() === "" ? null : Number(value);
}
